import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationSampleTypeLaboratoryCreateRequest, ConfigurationSampleTypeLaboratoryPatchInBatchRequest, ConfigurationSampleTypeLaboratoryResponse } from '@/modules/configurationModule/detail/local-samples/local-sample-types/services/local-sample-types.dto'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class SampleTypeLaboratoriesConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationSampleTypeLaboratoryResponse>> {
        const response = await axios.put(`/configuration/laboratories/${laboratoryId}/sampleTypeLaboratories`, filterModel, { params })
        return response.data
    }

    async getSampleTypeLaboratoryById(laboratoryId: number, sampleTypeLaboratoryId: number): Promise<ConfigurationSampleTypeLaboratoryResponse> {
        const response = await axios.get(`/configuration/laboratories/${laboratoryId}/sampleTypeLaboratories/${sampleTypeLaboratoryId}`)
        return response.data
    }

    async createSampleTypeLaboratory(laboratoryId: number, request: ConfigurationSampleTypeLaboratoryCreateRequest): Promise<ConfigurationSampleTypeLaboratoryResponse> {
        const response = await axios.post(`/configuration/laboratories/${laboratoryId}/sampleTypeLaboratories`, request)
        return response.data
    }

    async deleteSampleTypeLaboratory(laboratoryId: number, sampleTypeLaboratoryIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete(`/configuration/laboratories/${laboratoryId}/sampleTypeLaboratories/batch`, { data: sampleTypeLaboratoryIds })
        return response.data
    }

    async patchSampleTypeLaboratory(laboratoryId: number, requests: ConfigurationSampleTypeLaboratoryPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch(`/configuration/laboratories/${laboratoryId}/sampleTypeLaboratories/batch`, requests)
        return response.data
    }
}

export const sampleTypeLaboratoriesConfigurationServices = new SampleTypeLaboratoriesConfigurationServices()
